// API Configuration - uses global set in index.html or defaults to relative
const API_BASE = typeof window !== 'undefined' && window.API_BASE 
  ? window.API_BASE 
  : '/api';

// Helper function to make authenticated API calls
export const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('auth_token');
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers
  });
  
  if (response.status === 401) {
    // Token expired or invalid - logout
    localStorage.removeItem('auth_token');
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }
  
  return response;
};

export default API_BASE;
